/** Walk/idle locomotion state (sim-side; presentation may bob separately). */

export type LocomotionAnimState = "idle" | "walk" | "attack" | "death" | string;

export type LocomotionBody = {
  animState: LocomotionAnimState;
  animHoldUntil: number;
  arrived: boolean;
};

/**
 * Walk/idle transitions with hold + arrived lock.
 * Does not reset animTime on locomotion flips (keeps bob phase stable).
 */
export function stepLocomotionAnim(
  e: LocomotionBody,
  time: number,
  prefSpd: number,
  walkEnter: number,
  walkExit: number,
  holdSec: number,
): void {
  if (e.animState === "attack" || e.animState === "death") return;

  if (e.arrived) {
    if (e.animState !== "idle") {
      e.animState = "idle";
      e.animHoldUntil = time + holdSec;
    }
    return;
  }

  const canFlip = time >= e.animHoldUntil;
  if (e.animState === "walk") {
    if (canFlip && prefSpd < walkExit) {
      e.animState = "idle";
      e.animHoldUntil = time + holdSec;
    }
  } else if (e.animState === "idle") {
    if (canFlip && prefSpd > walkEnter) {
      e.animState = "walk";
      e.animHoldUntil = time + holdSec;
    }
  } else {
    e.animState = prefSpd > walkEnter ? "walk" : "idle";
    e.animHoldUntil = time + holdSec;
  }
}
